export default "__VITE_ASSET__C0SrlH69__"